import type { ReactElement } from 'react'
import type { Step } from '../state/types.js'
import { StartScreen } from './StartScreen.js'
import { JobBriefScreen } from './JobBriefScreen.js'
import { ProofBundleScreen } from './ProofBundleScreen.js'
import { CaptureScreen } from './CaptureScreen.js'
import { VerifyPassedScreen } from './VerifyPassedScreen.js'
import { VerifyFailedScreen } from './VerifyFailedScreen.js'
import { SummaryScreen } from './SummaryScreen.js'
import { JobClosedScreen } from './JobClosedScreen.js'

export const SCREENS: Record<Step, () => ReactElement | null> = {
  'start': StartScreen,
  'job-brief': JobBriefScreen,
  'proof-bundle': ProofBundleScreen,
  'capture': CaptureScreen,
  'verify-passed': VerifyPassedScreen,
  'verify-failed': VerifyFailedScreen,
  'summary': SummaryScreen,
  'job-closed': JobClosedScreen,
}
